module.exports = __webpack_public_path__ + "static/media/print-icon.652cb9e3.svg";